/**
 * @desc 时效设置-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.ProductTimelinessSettingResponseDto>
>;
export function request(
  params: API.basics.timelinessSetting.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessSetting/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
